/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedVentureFundVariantRequestDto } from '../../models/backend-patched-venture-fund-variant-request-dto';
import { BackendVentureFundVariantDto } from '../../models/backend-venture-fund-variant-dto';

export interface VentureFundsVentureFundVariantsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedVentureFundVariantRequestDto;
}

export function ventureFundsVentureFundVariantsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsVentureFundVariantsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendVentureFundVariantDto>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsVentureFundVariantsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendVentureFundVariantDto>;
    }),
  );
}

ventureFundsVentureFundVariantsPartialUpdate.PATH = '/api/venture_funds/venture-fund-variants/{id}/';
